"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function withLogger(store) {
    store.onAll().subscribe(function (_a) {
        var key = _a.key, previousValue = _a.previousValue, value = _a.value;
        console.info("%c \u2941 " + key, 'background-color: rgb(96, 125, 139); color: #fff; padding: 2px 8px 2px 0;', previousValue, '→', value);
    });
    return store;
}
exports.withLogger = withLogger;
//# sourceMappingURL=withLogger.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/undux/dist/src/plugins/withLogger.js
// module id = 366
// module chunks = 0